import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import MailWarningIcon from "@/assets/icons/svg/mail-warning.icon.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'link-university-email-dialog',
  props: {
    isVisible: { type: Boolean },
    onClose: null,
    expectedEmail: null
  },
  emits: ["on-continue"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (e: "on-continue"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isVisible: boolean;
  onClose: () => void;
  expectedEmail: string;
}





const closeDialog = () => {
  props.onClose();
};

const onContinue = () => {
  emit("on-continue");
  closeDialog();
};

return { __sfc: true,props, emit, closeDialog, onContinue, BaseDialog, MailWarningIcon }
}

})